import React, { ReactNode } from 'react';
import { HelpToolTip } from './HelpToolTip';
import { ValidationResult } from '../../util/validation/interfaces';

export interface TextFieldProps {
  label: string;
  required?: boolean;
  validation?: ValidationResult;
  htmlFor?: string;
  help?: string;
  disabled?: boolean;
  hidden?: boolean;
  isNew?: boolean;
}

export function Label(props: TextFieldProps): ReactNode {
  const classes: string[] = ['flex', 'flex-grow-1', 'min-w-0', 'overflow-hidden', 'text-overflow-ellipsis', 'white-space-nowrap'];
  if (props.validation && !props.validation?.valid) {
    classes.push('alert');
  }
  if (props.isNew && props.validation && props.validation?.valid) {
    classes.push('text-primary-500');
  }
  if (props.disabled) {
    classes.push('opacity-30');
  }
  return <label className={`flex justify-content-between gap-1 max-w-full min-w-0 overflow-hidden white-space-nowrap ${props.hidden ? 'opacity-0' : ''}`} htmlFor={props.htmlFor}>
    <span className={classes.join(' ')}>{
      props.label}
      {props.required && '*'}
    </span>
    <div className={'flex flex-shrink-0 gap-1'}>
      {props.validation?.reason && <div><i className={'pi pi-exclamation-triangle mx-2 alert'}/></div>}
      {props.help && <HelpToolTip for={props.htmlFor} help={props.help}/>}
    </div>
  </label>;
}

export default Label;
